import React from 'react';
import Language from '../../../Layout/Header/Language';
import Logo from '../../../assets/logo.svg';
import CustomLink from '../../CustomLink';

const Header = ({ scrolledPastBanner, showLanguageSelector = true, homePath = '/' }) => {
  return (
    <div className="t-sticky t-top-0 t-z-[100]">
      <div className={`t-bg-surface t-transition-all t-duration-200 ${scrolledPastBanner ? 't-border-b t-border-g200' : ''}`}>
        <div className="t-w-full t-max-w-[1260px] t-mx-auto t-px-4 lg:t-px-8 t-h-[52px] t-flex t-items-center t-justify-between">

          {/* Left: equal flex spacer */}
          <div className="t-flex-1" />

          {/* Center: logo */}
          <CustomLink to={homePath}>
            <img src={Logo} alt="riise" className="t-h-12 t-w-auto" />
          </CustomLink>

          {/* Right: language selector, same flex weight as left */}
          <div className="t-flex-1 t-flex t-justify-end">
            {showLanguageSelector && (
              <div className="t-inline-flex t-items-center t-border t-border-g200 t-rounded-md t-px-1 hover:t-border-navy t-transition-colors [&_.m-lang]:!t-mt-0">
                <Language darkText />
              </div>
            )}
          </div>

        </div>
      </div>
    </div>
  );
};

export default Header;
